import React from "react";
import { Crown } from "lucide-react";
import { mediaUrl } from "@/lib/api";

export function Avatar({ r, size }) {
  const src = mediaUrl(r.photo);
  return src ? <img src={src} alt={r.name} className={`${size} rounded-full object-cover`} /> : <span className={`${size} flex items-center justify-center rounded-full bg-slate-200 font-display font-black text-slate-500`}>{(r.name || "?")[0]}</span>;
}

const PODIUM = [
  { idx: 1, h: "h-24", ring: "ring-slate-300", size: "h-20 w-20 sm:h-24 sm:w-24", bg: "from-slate-200 to-slate-300", label: "2º" },
  { idx: 0, h: "h-32", ring: "ring-amber-400", size: "h-24 w-24 sm:h-32 sm:w-32", bg: "from-amber-300 to-amber-500", label: "1º" },
  { idx: 2, h: "h-16", ring: "ring-orange-300", size: "h-20 w-20 sm:h-24 sm:w-24", bg: "from-orange-200 to-orange-400", label: "3º" },
];

export function Podium({ ranking, testPrefix = "podium" }) {
  return (
    <div className="mt-6 grid grid-cols-3 items-end gap-2 sm:gap-4">
      {PODIUM.map((p) => {
        const r = ranking[p.idx];
        if (!r) return <div key={p.idx} />;
        return (
          <div key={p.idx} data-testid={`${testPrefix}-${p.idx + 1}`} className="animate-fade-up flex flex-col items-center text-center" style={{ animationDelay: `${p.idx * 120}ms` }}>
            {p.idx === 0 && <Crown className="mb-1 h-8 w-8 text-amber-500" />}
            <div className={`rounded-full ring-4 ${p.ring} ring-offset-2`}><Avatar r={r} size={p.size} /></div>
            <p className="mt-2 line-clamp-2 font-display text-sm font-bold text-slate-900 sm:text-base">{r.name}</p>
            <p className="text-xs font-bold text-[#1B7A45]">{r.points} pts</p>
            <div className={`mt-2 flex w-full ${p.h} items-start justify-center rounded-t-2xl bg-gradient-to-b ${p.bg} pt-2 font-display text-2xl font-black text-white shadow-inner`}>{p.label}</div>
          </div>
        );
      })}
    </div>
  );
}

export function RankList({ ranking, testPrefix = "rank-row" }) {
  return (
    <div className="mt-4 space-y-2">
      {ranking.slice(3).map((r, i) => (
        <div key={r.id} data-testid={`${testPrefix}-${r.id}`} className="flex items-center justify-between rounded-2xl border border-slate-200 bg-white px-4 py-2.5 shadow-sm">
          <div className="flex min-w-0 items-center gap-3">
            <span className="w-8 text-center font-display text-sm font-black text-slate-400">{i + 4}º</span>
            <Avatar r={r} size="h-10 w-10" />
            <p className="truncate font-display text-base font-bold text-slate-900">{r.name}</p>
          </div>
          <span className="font-display text-xl font-black text-[#1B7A45]">{r.points} <span className="text-xs font-semibold text-slate-400">pts</span></span>
        </div>
      ))}
    </div>
  );
}
